module.exports = __webpack_public_path__ + "static/z_tall_f4-8092f33d78474c6eb1056f8b7e82b035.jpg";